import { Component } from '@angular/core';

@Component({
  selector: 'val-main',
  template: '<router-outlet></router-outlet>',
})
export class ValMainComponent {
  constructor(
  ) {
    console.log('ValMainComponent');
   }
}


